import { useQuery } from 'react-query';
import { App } from 'src/core/types';

import axios from './axios';

export function useAppQuery() {
  return useQuery<App>('app', async () => {
    return axios.get<App>('/posht/picasso/theme/').then((res) => res.data);
  });
}
